(function () {
    angular
      .module('kareo.ui.shared.directives.k-enrl-common-payers', [
        'kareo.ui.shared.modules.api.enrollments-service',
        'kareo.ui.shared.directives.k-constants',
        'kareo.ui.shared.modules.data',
        'kareo.ui.shared.modules.featureSet'
      ])
      .directive('kEnrlCommonPayers', kEnrlCommonPayers);
  
    function kEnrlCommonPayers() {
      const directive = {
        bindToController: true,
        controller,
        controllerAs: 'vm',
        scope: {
          payers: '=',
          duplicatePayerCheck: '<?',
          addedPayers: '<?',
          selectPayerCallback: '&',
          allowMultipleInsurances: '='
        },
        template: require('./k-enrl-common-payers.pug')()
      };
  
      return directive;
    }
  
    //----------------------
  
    controller.$inject = ['$filter', '$scope', 'TRIZETTO_CLEARINGHOUSE_ID', 'enrollmentsService', 'featureSet', 'practice'];
  
    function controller($filter, $scope, TRIZETTO_CLEARINGHOUSE_ID, enrollmentsService, featureSet, practice) {
      const vm = this;
  
      vm.addPayer = addPayer;
      vm.visibleCommonPayers = visibleCommonPayers;
  
      init();
  
      //----------------------
  
      function init() {
        vm.hasError = false;
        vm.isLoading = true;
        vm.isPhase2Feature = false;
  
        enrollmentsService.getCommonPayers().then((payers) => {
          vm.hasError = false;
          vm.isLoading = false;
          vm.commonPayers = payers;
          startWatch();
        }, () => {
          vm.isLoading = false;
          vm.hasError = true;
        });
  
        featureSet.load().then((features) => {
          vm.isInsuranceAdmin = features['dark-feature.converged-insurance-admin'];
          vm.isPhase2Feature = features['dark-feature.enrollments-upgrade-phase2']
                            || features['dark-feature.enrollments-upgrade-phase3'];
        });
  
        practice.get().then((result) => {
          vm.isPmEnabled = result.pmenabled;
        });
      }
  
      function addPayer(payer) {
        if (vm.duplicatePayerCheck) {
          markDuplicatePayer(payer);
        }

        if(!vm.allowMultipleInsurances){
          vm.payers = [payer];
        }
        else{
          vm.payers.push(payer);
        }
        vm.selectPayerCallback({ 'payer': payer });
        updateCommonPayers();
      }
  
      function markDuplicatePayer(payer) {
        for (let index = 0; index < vm.addedPayers.length; index++) {
          const addedPayer = vm.addedPayers[index];
          if (addedPayer.payerNumber === payer.payerNumber) {
            payer.isDuplicate = true;
            break;
          }
        }
      }
  
      function startWatch() {
        updateCommonPayers();
      }

      function updateCommonPayers(){
        $scope.$watch('vm.payers.length', () => {
          for (let cpi = 0; cpi < vm.commonPayers.length; cpi++) {
            const commonPayer = vm.commonPayers[cpi];
            let isAdded = false;
  
            for (let spi = 0; spi < vm.payers.length; spi++) {
              const selectedPayer = vm.payers[spi];
  
              if (selectedPayer.payerNumber === commonPayer.payerNumber) {
                isAdded = true;
  
                const validationType = commonPayer.payerValidationType;
  
                // Ensure validation applies if selected by search
                if (selectedPayer.payerValidationType !== validationType) {
                  selectedPayer.payerValidationType = validationType;
                }
  
                break;
              }
            }
  
            commonPayer.isAdded = isAdded;
          }
        });
      }
  
      function visibleCommonPayers() {
        const commonPayers = $filter('filter')(vm.commonPayers, (payer) => {
          const { clearinghouseId } = payer;
          return !payer.isAdded && clearinghouseId === TRIZETTO_CLEARINGHOUSE_ID;
        });
        return $filter('orderBy')(commonPayers, 'name');
      }
    }
  })();
  